// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__29731","vLegacy":"SelectSecondary_vLegacy__2JXgF","error":"SelectSecondary_error__1IyBg","disabled":"SelectSecondary_disabled__1xbTn"};